import React from "react";
import { ambassadors } from "../../services/ambassadors";
import {
  AmbassadorProfile,
  ambassadorDay,
  weeklyDecisions,
} from "../../types/ambassadors";

export default function WeeklyReviews({
  profile,
  canReview,
  busy,
  run,
}: {
  profile: AmbassadorProfile;
  canReview: boolean;
  busy: boolean;
  run: (
    action: () => Promise<unknown>,
    form?: HTMLFormElement,
  ) => Promise<unknown>;
}) {
  const today = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Tehran",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());
  return (
    <section className="amb-card">
      <span className="amb-eyebrow">بازبینی مسیر همکاری</span>
      <h2>ارزیابی هفتگی و اقدام بعدی</h2>
      <p className="amb-muted">
        استمرار، کیفیت محتوا، مشارکت واقعی و مشکلات حل‌شده را بررسی کنید. تصمیم
        این فرم به‌صورت خودکار وضعیت سفیر را تغییر نمی‌دهد.
      </p>
      {canReview && (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            const form = e.currentTarget;
            const data = new FormData(form);
            run(
              () =>
                ambassadors.weeklyReview(
                  profile.id,
                  Object.fromEntries(data.entries()),
                ),
              form,
            );
          }}
        >
          <fieldset disabled={busy}>
            <div className="amb-grid">
              <label>
                شروع بازه هفت‌روزه
                <input
                  name="weekStart"
                  type="date"
                  required
                  max={today}
                  defaultValue={today}
                />
              </label>
              <label>
                تصمیم سرپرست
                <select name="decision">
                  {Object.entries(weeklyDecisions).map(([key, title]) => (
                    <option value={key} key={key}>
                      {title}
                    </option>
                  ))}
                </select>
              </label>
            </div>
            <label>
              جمع‌بندی ارزیابی
              <textarea
                name="summary"
                maxLength={4000}
                required
                placeholder="استمرار فعالیت، کیفیت انتشار، تعامل واقعی و وضعیت مشکلات…"
              />
            </label>
            <label>
              اقدام بعدی و مسئول پیگیری
              <textarea
                name="nextAction"
                maxLength={4000}
                required
                placeholder="مثلاً هماهنگی آموزش مجدد با پشتیبان تا پایان هفته"
              />
            </label>
            <button>ثبت ارزیابی هفتگی</button>
          </fieldset>
        </form>
      )}
      {profile.weeklyReviews?.map((review) => (
        <article className="amb-message" key={review.id}>
          <div className="amb-section-title">
            <strong>هفته از {ambassadorDay(review.weekStart)}</strong>
            <span className="amb-badge">
              {weeklyDecisions[review.decision]}
            </span>
          </div>
          <p className="amb-pre">{review.summary}</p>
          <p className="amb-pre">
            <strong>اقدام بعدی: </strong>
            {review.nextAction}
          </p>
        </article>
      ))}
      {!profile.weeklyReviews?.length && (
        <p className="amb-muted">هنوز ارزیابی هفتگی ثبت نشده است.</p>
      )}
    </section>
  );
}
